<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="fill-height d-flex flex-column">
            <div style="flex:1; overflow:hidden">
                <employment-doc-view
                    v-bind="{
                        value: fields,
                        pages,
                        mode: 'view',
                    }"
                />
            </div>
            <v-divider />
            <div class="v-btn-group flex-wrap my-12">
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="exit">
                    <span> 확인 </span>
                </v-btn>
            </div>
            <client-loader v-bind="{ loading }" />
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { initEmploymentForm } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import ClientLoader from "@/components/client/dumb/client-loader.vue";
import EmploymentDocView from "@/components/dashboard/common/employment/doc/employment-doc-view.vue";

export default {
    components: {
        BottomSheet,
        ClientLoader,
        EmploymentDocView,
    },
    props: {
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),

        index: 0,
        shows: false,
        loading: false,
    }),
    computed: {
        title() {
            return `근로계약서 미리보기 - "${this.form?.name}"`;
        },
        pages() {
            return this.form?.pages || [];
        },
        fields() {
            return this.form?.fields || [];
        },
    },
    mounted() {
        if (this.shows) this.init();
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { form } = await api.v1.company.employment.forms.get({ _id: this.value._id });
                this.form = initEmploymentForm(form);
            } finally {
                this.loading = false;
            }
        },
        exit() {
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
